import {
    GetPatientOverviewSeveritiesResponsePayload,
    ValueType
} from "pokal_api"

function mockPatientSeverities(): GetPatientOverviewSeveritiesResponsePayload {
    return {
        relative: {
            [ValueType.PHQUESTIONNAIRE]: {
                improve: false,
                difference: 4,
                increase: true,
                percentage: 80,
                significance: 3
            },
            [ValueType.SFQUESTIONNAIRE]: {
                improve: false,
                difference: 4,
                increase: true,
                percentage: 80,
                significance: 3
            },
            [ValueType.MOOD]: {
                improve: false,
                difference: 4,
                increase: true,
                percentage: 80,
                significance: 3
            },
            [ValueType.SLEEP_DURATION]: {
                improve: false,
                difference: 4,
                increase: true,
                percentage: 80,
                significance: 3
            },
            [ValueType.SLEEP_LATENCY]: {
                improve: false,
                difference: 4,
                increase: true,
                percentage: 80,
                significance: 3
            },
            [ValueType.SLEEP_HEART_RATE]: {
                improve: false,
                difference: 4,
                increase: true,
                percentage: 80,
                significance: 3
            },
            [ValueType.SLEEP_HEART_RATE_VARIABILITY]: {
                improve: false,
                difference: 4,
                increase: true,
                percentage: 80,
                significance: 3
            },
            [ValueType.STEPS]: {
                improve: false,
                difference: 4,
                increase: true,
                percentage: 80,
                significance: 3
            }
        },
        absolute: {
            [ValueType.PHQUESTIONNAIRE]: 5,
            [ValueType.SFQUESTIONNAIRE]: 5,
            [ValueType.MOOD]: 5
        },
        last: {
            [ValueType.PHQUESTIONNAIRE]: {
                id: "mock_phq_value",
                value: 20,
                date: new Date()
            },
            [ValueType.SFQUESTIONNAIRE]: {
                id: "mock_sfq_value",
                value: 5,
                date: new Date()
            },
            [ValueType.MOOD]: {
                id: "mock_mood_value",
                value: 1,
                date: new Date()
            },
            [ValueType.SLEEP_DURATION]: {
                id: "mock_sleep_duration_value",
                value: 20000,
                date: new Date()
            },
            [ValueType.SLEEP_LATENCY]: {
                id: "mock_sleep_latency_value",
                value: 1000,
                date: new Date()
            },
            [ValueType.SLEEP_HEART_RATE]: {
                id: "mock_sleep_heart_rate_value",
                value: 60,
                date: new Date()
            },
            [ValueType.SLEEP_HEART_RATE_VARIABILITY]: {
                id: "mock_sleep_heart_rate_variability_value",
                value: 78,
                date: new Date()
            },
            [ValueType.STEPS]: {
                id: "mock_steps_value",
                value: 4000,
                date: new Date()
            }
        }
    }
}

export default mockPatientSeverities
